export default {
    BULKPAYMENTLIST: ({ savings_id }) => `wage-disbursement/upload-payment-wages/${savings_id}/`,
    CHECKERSLIST: ({ savings_id }) => `bulk-payments/operator-list/${savings_id}/`,
    // STAGEBULKPAYMENT: `bulk-payments/stage/`,
    STAGEBULKPAYMENT:  `wage-disbursement/upload-payment-wages/`,
    SINGLEBULKPAYMENT: ({ id }) => `/wage-disbursement/${id}/process/upload-payment-wages/`,
    DELETE_BULK_RECORD:`bulk-payments/delete/`,
}


